<template>
  <section>
    <v-card v-if="!landscape">
      <v-toolbar color="primary" dark dense style="height: 40px;">
        <v-layout row align-center>
          <v-flex shrink pb-1>
            <h3>Summary</h3>
          </v-flex>
          <v-divider vertical class="mx-3 mb-1"></v-divider>
          <v-flex shrink pb-1>
            <h4 class="nobold">
              Invoice Reference:
              <b>{{invoice.id}}</b>
              &nbsp
              <v-icon small @click="copyInvoiceID()">file_copy</v-icon>
              &nbsp·&nbsp
              {{ timesheet ? getDate(timesheet.start_time) : getDate(invoice.date)}}
              {{ timesheet ? ' to ' + getDate(timesheet.end_time) : ''}}
            </h4>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <v-layout row class="summaryHeight">
        <v-flex xs6 md6 pt-1>
          <v-layout align-center justify-center>
            <h4 class="grey--text">Pay</h4>
          </v-layout>
          <v-list subheader dense>
            <v-list-tile avatar class="denseTile">
              <v-list-tile-content>
                <v-list-tile-title>Cash · {{formatter.format(invoice.totals.cash/100)}}</v-list-tile-title>
                <v-list-tile-sub-title>{{getCashJobs()}} Trips</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="denseTile">
              <v-list-tile-content>
                <v-list-tile-title>Card · {{formatter.format(invoice.totals.card/100)}}</v-list-tile-title>
                <v-list-tile-sub-title>{{getCardJobs()}} Trips</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="denseTile">
              <v-list-tile-content>
                <v-list-tile-title>Account · {{formatter.format(invoice.totals.account/100)}}</v-list-tile-title>
                <v-list-tile-sub-title>{{getAccountJobs()}} Trips</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider inset class="mr-1 mt-3 mb-1"></v-divider>
            <v-list-tile class="denseTileSingle">
              <v-list-tile-content>
                <v-list-tile-title>Charges · {{formatter.format(invoice.totals.charges/100)}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="denseTileSingle">
              <v-list-tile-content>
                <v-list-tile-title>Credits · {{formatter.format(invoice.totals.credits/100)}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="denseTileSingle">
              <v-list-tile-content>
                <v-list-tile-title>Extras · {{formatter.format(invoice.totals.extras/100)}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="denseTileSingle">
              <v-list-tile-content>
                <v-list-tile-title>Service Fee · {{formatter.format(invoice.totals.serviceFee/100)}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider inset class="mr-1 mt-3"></v-divider>
            <v-list-tile class="denseTileSingle">
              <v-list-tile-content>
                <v-list-tile-title>
                  <b>Payable · {{formatter.format(invoice.totals.payable/100)}}</b>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="denseTileSingle" v-if="invoice.paid == 1">
              <v-list-tile-content>
                <v-list-tile-title>
                  <b>Paid Date · {{invoice.paid_time}}</b>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
        <v-divider vertical></v-divider>
        <v-flex xs6 md6 pl-1 pt-1>
          <v-layout align-center justify-center>
            <h4 class="grey--text">Timesheet</h4>
          </v-layout>
          <v-list subheader dense v-if="timesheet">
            <v-list-tile class="denseTile">
              <v-list-tile-content>
                <v-list-tile-title>Hours Waiting for Job</v-list-tile-title>
                <v-list-tile-sub-title>{{Math.round(timesheet.hours_waiting_for_job*100)/100}} Hours</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="denseTile">
              <v-list-tile-content>
                <v-list-tile-title>Hours on Break</v-list-tile-title>
                <v-list-tile-sub-title>{{Math.round(timesheet.hours_on_break*100)/100}} Hours</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="denseTile">
              <v-list-tile-content>
                <v-list-tile-title>Hours on Job</v-list-tile-title>
                <v-list-tile-sub-title>{{Math.round(timesheet.hours_on_job*100)/100}} Hours</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider inset class="mr-1 mt-3 mb-2"></v-divider>
            <v-list-tile class="denseTile">
              <v-list-tile-content>
                <v-list-tile-title>Hourly Rate</v-list-tile-title>
                <v-list-tile-sub-title>{{formatter.format(timesheet.hours_pob)}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
      <v-flex pr-2 py-1>
        <v-layout justify-end align-end>
          <v-btn class="text-none smallButton" color="primary" outline>Export</v-btn>
        </v-layout>
      </v-flex>
    </v-card>
    <v-card v-if="landscape">
      <v-layout column>
        <v-flex xs12 m12>
          <v-toolbar color="primary" dark dense style="height: 40px;">
            <v-layout row align-center>
              <v-flex shrink pb-1>
                <h3>Summary</h3>
              </v-flex>
              <v-divider vertical class="mx-3 mb-1"></v-divider>
              <v-flex shrink pb-1>
                <h4 class="nobold">
                  Invoice Reference:
                  <b>{{invoice.id}}</b>
                  &nbsp
                  <v-icon small @click="copyInvoiceID()">file_copy</v-icon>
                  &nbsp·&nbsp
                  {{ timesheet ? getDate(timesheet.start_time) : getDate(invoice.date)}}
                  {{ timesheet ? ' to ' + getDate(timesheet.end_time) : ''}}
                </h4>
              </v-flex>
            </v-layout>
          </v-toolbar>
        </v-flex>
        <v-divider class="grey lighten-2"></v-divider>
        <v-flex xs12 md12 pl-1 pt-1 pb-1>
          <v-layout row align-center>
            <v-flex xs1 md1 pb-1>
              <h4 class="text-xs-center grey--text">Pay</h4>
            </v-flex>
            <v-divider inset class="grey lighten-2 mb-1" vertical></v-divider>
            <v-flex shrink pl-3 pr-3>
              <h4 class="nobold">Cash · {{formatter.format(invoice.totals.cash/100)}}</h4>
              <h5 class="nobold grey--text text--darken-1">{{getCashJobs()}} Trips</h5>
            </v-flex>
            <v-flex shrink pl-3 pr-3>
              <h4 class="nobold">Card · {{formatter.format(invoice.totals.card/100)}}</h4>
              <h5 class="nobold grey--text text--darken-1">{{getCardJobs()}} Trips</h5>
            </v-flex>
            <v-flex shrink pl-3 pr-3>
              <h4 class="nobold">Account · {{formatter.format(invoice.totals.account/100)}}</h4>
              <h5 class="nobold grey--text text--darken-1">{{getAccountJobs()}} Trips</h5>
            </v-flex>
            <v-divider inset class="grey lighten-2 mb-1" vertical></v-divider>
            <v-flex shrink pl-3 pr-3>
              <h4 class="nobold">Charges · {{formatter.format(invoice.totals.charges/100)}}</h4>
            </v-flex>
            <v-flex shrink pl-3 pr-3>
              <h4 class="nobold">Credits · {{formatter.format(invoice.totals.credits/100)}}</h4>
            </v-flex>
            <v-flex shrink pl-3 pr-3>
              <h4 class="nobold">Extras · {{formatter.format(invoice.totals.extras/100)}}</h4>
            </v-flex>
            <v-flex shrink pl-3 pr-3>
              <h4 class="nobold">Service Fee · {{formatter.format(invoice.totals.serviceFee/100)}}</h4>
            </v-flex>
            <v-divider inset class="grey lighten-2 mb-1" vertical></v-divider>
            <v-flex shrink pl-3 pr-3>
              <h4 class="nobold">
                <b>Payable · {{formatter.format(invoice.totals.payable/100)}}</b>
              </h4>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12 pl-1 pt-1 pb-1>
          <v-layout row align-center>
            <v-flex xs1 md1 pb-1>
              <h4 class="text-xs-center grey--text">Timesheet</h4>
            </v-flex>
            <v-divider inset class="grey lighten-2 mb-1" vertical></v-divider>
            <v-flex shrink pl-3 pr-3>
              <h4 class="nobold">Hours Waiting for Job</h4>
              <h5
                class="nobold grey--text text--darken-1"
              >{{Math.round(timesheet.hours_waiting_for_job*100)/100}} Hours</h5>
            </v-flex>
            <v-flex shrink pl-3 pr-3>
              <h4 class="nobold">Hours on Break</h4>
              <h5
                class="nobold grey--text text--darken-1"
              >{{Math.round(timesheet.hours_on_break*100)/100}} Hours</h5>
            </v-flex>
            <v-flex shrink pl-3 pr-3>
              <h4 class="nobold">Hours on Job</h4>
              <h5
                class="nobold grey--text text--darken-1"
              >{{Math.round(timesheet.hours_on_job*100)/100}} Hours</h5>
            </v-flex>
            <v-divider inset class="grey lighten-2 mb-1" vertical></v-divider>
            <v-flex shrink pl-3 pr-3>
              <h4 class="nobold">
                <b>Hourly Rate</b>
              </h4>
              <h5 class="nobold grey--text text--darken-1">
                <b>{{formatter.format(timesheet.hours_pob)}}</b>
              </h5>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink pr-2>
              <v-btn class="text-none smallButton" color="primary" outline>Export</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </section>
</template>

<script>
export default {
  name: "invoice_summary",
  components: {},
  props: {
    invoice: Object,
    timesheet: Object,
    loading: Boolean,
    landscape: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      formatter: Function
    };
  },
  beforeMount: function() {
    this.formatter = new Intl.NumberFormat("en-UK", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2
    });
  },
  methods: {
    getDate: function(date) {
      let parsedDate = new Date(date);
      let dd = parsedDate.getDate();
      let mm = parsedDate.getMonth() + 1;

      var yyyy = parsedDate.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      let formattedDate = dd + "/" + mm + "/" + yyyy;

      return formattedDate;
    },
    getCashJobs: function() {
      let total = 0;
      this.invoice.jobs.forEach(function(job) {
        if (job.payment_type == "cash") {
          total++;
        }
      });
      return total;
    },
    getCardJobs: function() {
      let total = 0;
      this.invoice.jobs.forEach(function(job) {
        if (job.payment_type == "card" || job.payment_type == "card_in_card") {
          total++;
        }
      });
      return total;
    },
    getAccountJobs: function() {
      let total = 0;
      this.invoice.jobs.forEach(function(job) {
        if (job.payment_type == "account") {
          total++;
        }
      });
      return total;
    },
    copyInvoiceID: function() {
      let textToCopy = document.createElement("textarea");
      textToCopy.value = this.invoice.id;
      document.body.appendChild(textToCopy);
      textToCopy.focus();
      textToCopy.select();
      document.execCommand("copy");
      document.body.removeChild(textToCopy);

      navigator.clipboard.writeText(textToCopy)

      this.$emit("copySuccessful");
    }
  }
};
</script>

<style scoped>
.smallList {
  transform: scale(0.9);
  transform-origin: left;
}

.denseTile {
  padding: 0 !important;
  margin: 0 !important;
  line-height: 12px !important;
  max-height: 45px !important;
}

.denseTileSingle {
  padding: 0 !important;
  margin: 0 !important;
  line-height: 12px !important;
  font-size: 10px !important;
  max-height: 25px !important;
}

.denseTileLandscape {
  padding: 0 !important;
  margin: 0 !important;
  line-height: 12px !important;
  max-height: 30px !important;
}

.summaryHeight {
  min-height: calc(50vh - 40px - 40px - 44px - 4px);
  max-height: calc(50vh - 40px - 40px - 44px - 4px);
  overflow-y: auto;
}

.smallButton {
  margin: 0;
  padding: 0;
}
</style>